

import React, { memo, useContext } from 'react';
import cx from 'classnames';
import DataTableRow from '../DataTableRow';
import { DATA_TABLE_HEADER_ROW_ID } from '../../../../../common/constants/row/dataTableRow';
import { DataTableContext } from '../../context/dataTableContext';
import '../../styles/_data-table-header-row.scss';





const DataTableHeaderRow = (props) => {
  const { children } = props;

  const { styleType } = useContext(DataTableContext);

  return (
    <DataTableRow
      className={cx('data-table-header-row', {
        [`data-table-header-row--${styleType}`]: styleType
      })}
      rowIdAttr={DATA_TABLE_HEADER_ROW_ID}>

      {children}
    </DataTableRow>);

};

export default memo(DataTableHeaderRow);